// src/api/apiManager.js

const BASE_URL = 'http://127.0.0.1:8070/api/v1';

const getToken = () => {
    return localStorage.getItem('token');
};

const headers = (isAuth = false) => {
    const common = {
        'Content-Type': 'application/json',
    };
    if (isAuth) {
        const token = getToken();
        if (token) {
            common['Authorization'] = `Bearer ${token}`;
        }
    }
    return common;
};

const handleResponse = async (response) => {
    const data = await response.json();
    if (!response.ok) {
        const errorMessage = data?.message || 'Something went wrong';
        const error = new Error(errorMessage);
        error.status = response.status;
        error.data = data;
        throw error;
    }
    return data;
};

const apiManager = {
    post: async (url, body = {}, auth = false) => {
        const response = await fetch(`${BASE_URL}${url}`, {
            method: 'POST',
            headers: headers(auth),
            body: JSON.stringify(body)
        });
        return handleResponse(response);
    },

    get: async (url, auth = false) => {
        const response = await fetch(`${BASE_URL}${url}`, {
            method: 'GET',
            headers: headers(auth),
        });
        return handleResponse(response);
    },

    put: async (url, body = {}, auth = false) => {
        const response = await fetch(`${BASE_URL}${url}`, {
            method: 'PUT',
            headers: headers(auth),
            body: JSON.stringify(body),
        });
        return handleResponse(response);
    },

    delete: async (url, auth = false) => {
        const response = await fetch(`${BASE_URL}${url}`, {
            method: 'DELETE',
            headers: headers(auth),
        });
        return handleResponse(response);
    }
};

export default apiManager;
